// @storybook-skip: internal section of LessonsHomeScreen; covered by its screen story
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";
import { Text } from "react-native-paper";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { ContinueLearningCard } from "./ContinueLearningCard";
import type { ContinueLearningLesson } from "./types";

type Props = {
	title?: string;
	lessons: ContinueLearningLesson[];
	onResumePress: (lesson: ContinueLearningLesson) => void;
};

export const ContinueLearningSection = ({
	title,
	lessons,
	onResumePress,
}: Props) => {
	const { t } = useTranslation();
	const { isMobile } = useDevice();
	const cardWidth = isMobile ? 280 : 320;

	if (!lessons.length) {
		return null;
	}

	return (
		<Box gap={16}>
			<Box paddingHorizontal={16}>
				<Text variant="titleLarge">
					{title ?? t("lessons.home.continueLearning.title")}
				</Text>
			</Box>
			<ScrollView
				horizontal
				showsHorizontalScrollIndicator={false}
				contentContainerStyle={{ paddingHorizontal: 16, gap: 16 }}
			>
				{lessons.map((lesson) => (
					<ContinueLearningCard
						key={lesson.id}
						cardWidth={cardWidth}
						lesson={lesson}
						onResumePress={onResumePress}
					/>
				))}
			</ScrollView>
		</Box>
	);
};
